import React from "react";
import * as Ariakit from "@ariakit/react";

const ProgramDropdown = ({label, value, onChange, options, defaultLabel}) => {
    const selectId = `program-dropdown-${label.replace(/\s+/g, "-").toLowerCase()}`;

    return (
        <div className={'program-list__filter'}>
            <label htmlFor={selectId}>
                {label}
            </label>
            <div className={'program-list__select-wrapper'}>
                <Ariakit.SelectProvider
                    defaultValue={defaultLabel}
                    value={value || defaultLabel}
                    setValue={(val) => onChange({ target: { value: val } })}
                >

                    {/* Select button */}
                    <Ariakit.Select
                        id={selectId}
                        className="ariakit-button"
                    />

                    {/* Popover with scroll */}
                    <Ariakit.SelectPopover
                        gutter={4}
                        sameWidth
                        className="ariakit-popover"
                        placement="bottom-start"
                        flip={false} // always stay below
                        style={{maxHeight: "50vh", overflowY: "auto"}}
                    >
                        <Ariakit.SelectItem
                            value={defaultLabel}
                            className="ariakit-select-item"
                        >
                            {defaultLabel}
                        </Ariakit.SelectItem>

                        {options.map((opt) => (
                            <Ariakit.SelectItem
                                key={opt}
                                value={opt}
                                className="ariakit-select-item"
                            >
                                {opt}
                            </Ariakit.SelectItem>
                        ))}
                    </Ariakit.SelectPopover>
                </Ariakit.SelectProvider>
            </div>
        </div>
    );
};

export default ProgramDropdown;
